/**
 * Strip falsy filter values for the list wire protocol.
 * Matches Company `formatFilters` behaviour exactly (P3 parity).
 *
 * @param {Record<string, unknown>|null|undefined} filters
 * @param {{ arrayJoin?: string }} [options]
 * @returns {Record<string, unknown>}
 */
export function serializeFilters(filters, options = {}) {
  const { arrayJoin } = options;

  return Object.entries(filters || {}).reduce((acc, [key, value]) => {
    if (value == null || value === false || value === "") {
      return acc;
    }

    if (Array.isArray(value)) {
      if (value.length === 0) return acc;
      acc[key] =
        typeof arrayJoin === "string" ? value.join(arrayJoin) : value;
      return acc;
    }

    // Preserve Company truthy check for strings / numbers / objects
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
